<template>
  <div
    id="sidebar"
    class="sidebar-container"
    :class="{
      'open-navigation': isDropdownOpen.sidebar,
      'open-messages': isDropdownOpen.messages || isDropdownOpen.balance,
    }"
  >
    <ClientOnly>
      <div v-if="isUserLoaded && isLoggedIn" class="sidebar-container__get-bonus-button">
        <GetBonuseButton />
      </div>
      <CookiesWindow class="sidebar-container__cookies-window" />
      <div v-if="!isDropdownOpen.sidebar && !isLoggedIn" class="sidebar-container__auth">
        <BaseLogin
          v-if="!(isServerToken || isLoggedIn)"
          data-id="header-login-mobile-click"
        />
        <BaseRegister v-if="!isLoggedIn" />
      </div>
    </ClientOnly>
    <div class="sidebar">
      <div class="sidebar__content">
        <div class="sidebar__list">
          <template v-for="(button, indexButton) in sidebarButtons">
            <UiBtn
              :key="button.dataId"
              v-tooltip="{
                text: $t(button.tooltip),
                width: 80,
                rightPosition: true,
                trigger: 'hover',
              }"
              :color="button.color"
              :icon="button.icon"
              :data-id="button.dataId"
              size="l"
              :to="button.to"
              class="sidebar__item"
              :class="button.class"
              v-on="button.events"
            />
            <div v-if="indexButton === 1" :key="indexButton" class="sidebar__separator" />
          </template>
          <UiBtn
            :class="{ 'signal': profileInfoBonuses.isAvailable && isLoggedIn }"
            :active="isDropdownOpen.sidebar"
            color="secondary"
            :icon="isDropdownOpen.sidebar ? 'common/close' : 'navigation/menu'"
            data-id="toggle-menu-click"
            size="l"
            @click="toggleDropdown('sidebar')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseLogin from '@/components/Base/Login'
import BaseRegister from '~/components/Base/Register'

export default {
  name: 'AppSidebar',
  components: {
    BaseLogin,
    BaseRegister,
    CookiesWindow: () => import('@/components/App/CookiesWindow'),
    GetBonuseButton: () => import('@/components/Bonuses/components/GetBonuseButton'),
  },
  computed: {
    ...mapGetters('user', [
      'isUserLoaded',
      'isLoggedIn',
      'profileInfoBonuses',
      'isUserVerified',
    ]),
    ...mapGetters('base', [
      'isDropdownOpen',
      'isServerToken',
    ]),
    ...mapGetters('promotions', ['get_newPromotions']),
    ...mapGetters('limits', ['get_isLimitsHasBeenSet']),
    sidebarButtons() {
      return [
        {
          tooltip: 'sidebarItems.support',
          color: 'line',
          icon: 'navigation/headphones',
          dataId: 'quick-menu-item-support-link',
          class: 'sidebar__support',
          events: {
            click: this.open_globalModalSupport,
          },
        },
        {
          tooltip: 'sidebarItems.bonuses',
          color: 'line',
          icon: 'common/gift',
          dataId: 'quick-menu-item-bonuses-link',
          to: this.$paths.bonuses,
        },
        {
          tooltip: 'sidebarItems.promotions',
          color: 'line',
          icon: 'navigation/fire',
          dataId: 'quick-menu-item-promotions-link',
          to: this.$paths.bonusList,
        },
        {
          tooltip: 'sidebarItems.live',
          color: 'line',
          icon: 'navigation/cards-outline',
          dataId: 'quick-menu-item-slots-live-link',
          to: this.$paths.live,
        },
        {
          tooltip: 'sidebarItems.slots',
          color: 'line',
          icon: 'navigation/game',
          dataId: 'quick-menu-item-slots-link',
          to: this.$paths.slots,
        },
      ]
    },
  },
  methods: {
    ...mapActions('base', ['toggleDropdown']),
    ...mapActions('globalModal', ['open_globalModalSupport']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
